<!--
  @USE AS:
  import CheckDataList from '@/components/base/CheckDataList'

  components: { CheckDataList }

  <check-data-list
    label="loading"
    :isLoading="true"
    :isEmpty="true"
    v-if="isDataLoading || isDataEmpty"
  >
  </check-data-list>
-->

<template>
  <div :class="setClass"> <!-- .wrapper -->
    <div
      class="empty-list--inner"
      v-if="isEmpty"
    > <!-- .empty-list -->
      <i class="ico--empty-data"></i>
      <p>{{ common[lang]['no_data_found'] }}</p>
    </div> <!-- // .empty-list -->
  </div> <!-- // .wrapper -->
</template>

<script>
//= translations
import { changeLanguage } from '@/assets/js/translations/ChangeLanguage'
import { common } from '@/assets/js/translations/Common'

export default {
  name: 'check-data-list',

  mixins: [
    changeLanguage
  ],

  props: {
    label: [ String ],
    isLoading: [ Boolean ],
    isEmpty: [ Boolean ]
  },

  data () {
    return {
      common
    }
  },

  computed: {
    setClass () {
      var classList = ''

      if (this.isLoading) {
        classList = 'loader-wrap'
      }

      if (this.isEmpty) {
        classList = 'empty-list'
      }

      return classList
    }
  }
}
</script>
